// extracted by mini-css-extract-plugin
module.exports = {"gridItem":"GridItem_gridItem__IsJfe","text":"GridItem_text__yITKq","imageWrapper":"GridItem_imageWrapper__q_NMQ","title":"GridItem_title__N4mXi"};